/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';
import type { ApprovedAccessResponse } from './ApprovedAccessResponse';
import {
    ApprovedAccessResponseFromJSON,
    ApprovedAccessResponseFromJSONTyped,
    ApprovedAccessResponseToJSON,
    ApprovedAccessResponseToJSONTyped,
} from './ApprovedAccessResponse';

/**
 * 
 * @export
 * @interface ApprovedAccessResponsePagedResult
 */
export interface ApprovedAccessResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof ApprovedAccessResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<ApprovedAccessResponse>}
     * @memberof ApprovedAccessResponsePagedResult
     */
    data: Array<ApprovedAccessResponse> | null;
}

/**
 * Check if a given object implements the ApprovedAccessResponsePagedResult interface.
 */
export function instanceOfApprovedAccessResponsePagedResult(value: object): value is ApprovedAccessResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ApprovedAccessResponsePagedResultFromJSON(json: any): ApprovedAccessResponsePagedResult {
    return ApprovedAccessResponsePagedResultFromJSONTyped(json, false);
}

export function ApprovedAccessResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprovedAccessResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(ApprovedAccessResponseFromJSON)),
    };
}

export function ApprovedAccessResponsePagedResultToJSON(json: any): ApprovedAccessResponsePagedResult {
    return ApprovedAccessResponsePagedResultToJSONTyped(json, false);
}

export function ApprovedAccessResponsePagedResultToJSONTyped(value?: ApprovedAccessResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(ApprovedAccessResponseToJSON)),
    };
}

